const AccessibilityReadingMaskOpacityEnum = {
	"accessibility-reading-mask-opacity-light": "Opacité légère",
	"accessibility-reading-mask-opacity-medium": "Opacité moyenne",
	"accessibility-reading-mask-opacity-strong": "Opacité forte"
} as const;

export default AccessibilityReadingMaskOpacityEnum;

export const ReadingMaskOpacityValues: Record<keyof typeof AccessibilityReadingMaskOpacityEnum, number> = {
	"accessibility-reading-mask-opacity-light": 0.3,
	"accessibility-reading-mask-opacity-medium": 0.5,
	"accessibility-reading-mask-opacity-strong": 0.75
};
